import { isDevelopment } from '~/utils/environment.utils';
import { useEffectOnce } from 'react-use';
import { HBStatsigProviderInstance } from '~/common/Statsig/HBStatsigProvider';
import { useIsWrappedWithUnauthenticatedStatsigProvider } from '~/common/Statsig/Unauthenticated/useIsWrappedWithUnauthenticatedStatsigProvider';
import { useUnauthenticatedGlobal } from '~/providers/unauthenticated-global-context/useUnauthenticatedGlobal';

export const useWarnAboutNestedUnauthenticatedStatsigProvider = ({
    silenceIsNestedWarning,
    name
}: Pick<HBStatsigProviderInstance, 'silenceIsNestedWarning' | 'name'>) => {
    const { configStore } = useUnauthenticatedGlobal();
    const isWrappedWithUnauthenticatedStatsigProvider =
        useIsWrappedWithUnauthenticatedStatsigProvider();

    useEffectOnce(() => {
        if (
            isWrappedWithUnauthenticatedStatsigProvider &&
            !silenceIsNestedWarning &&
            (isDevelopment() || configStore.isE2E())
        ) {
            // eslint-disable-next-line no-console
            console.warn(
                'Detected a nested/redundant HBUnauthenticatedStatsigProvider - please remove it as the component is already wrapped with a StatsigProvider (if this provider is required, add "silenceIsNestedWarning" prop to it to dismiss this message)',
                'Nested provider name:',
                name
            );
        }
    });
};
